import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import React, { FormEvent, useState } from 'react';
import { motion } from 'framer-motion';

type CheckoutFormProps = {
  orderId: string;
  onSuccess: () => void;
  onProcessing: () => void;
  onError: (message: string) => void;
  isSubmitting: boolean;
};

function CheckoutForm({
  orderId,
  onSuccess,
  onProcessing,
  onError,
  isSubmitting,
}: CheckoutFormProps) {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js jeszcze się nie załadował
      return;
    }

    // Zmień stan widoku formularza
    onProcessing();
    setMessage(null);

    const { error } = await stripe.confirmPayment({
      // `Elements` zawiera element PaymentElement,
      // użyty do zbierania danych karty
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/koszyk/potwierdzenie?payment=success&orderId=${orderId}`,
      },
      redirect: 'always',
    });

    if (error) {
      // Pokazanie błędu
      setMessage(error.message || 'Wystąpił nieznany błąd.');
      onError(error.message || 'Wystąpił nieznany błąd.');
    } else {
      // Płatność się udała
      onSuccess();
    }
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" className="mb-6" />

      {message && (
        <div className="bg-red-50 border border-red-200 rounded p-3 mb-4 text-sm text-red-600">
          {message}
        </div>
      )}

      <div className="flex justify-end">
        <motion.button
          disabled={!stripe || isSubmitting}
          className={`px-6 py-3 rounded-md text-white font-medium transition-colors ${
            !stripe || isSubmitting
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-primary hover:bg-primary-dark'
          }`}
          whileHover={!isSubmitting && stripe ? { scale: 1.02 } : {}}
          whileTap={!isSubmitting && stripe ? { scale: 0.98 } : {}}
        >
          {isSubmitting ? (
            <>
              <svg
                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Przetwarzanie...
            </>
          ) : (
            'Zapłać teraz'
          )}
        </motion.button>
      </div>
    </form>
  );
}

export default CheckoutForm;
